<button (click)="logout()" mat-menu-item>
  <div class="icon-text-container">
    <mat-icon>logout</mat-icon>
    <span class="logout-text">{{ 'logout' | translate }}</span>
  </div>
</button>
